import { useEffect, useRef, memo, useContext } from 'react';
import { ThemeContext } from '../../Components/DarkMode/ThemeProvider';
import { useLocation } from 'react-router-dom';

function TradingViewWidget() {
  const container = useRef();
  const { isLightMode } = useContext(ThemeContext);
  //custom code
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");


  useEffect(() => {
    if (!container.current) return;

    container.current.innerHTML = '';

    const widgetContainer = document.createElement('div');
    widgetContainer.className = 'tradingview-widget-container';

    // Set background and text color
    widgetContainer.style.backgroundColor = 'var(--color-BasicBg)';
    widgetContainer.style.color = 'var(--color-PrimaryText)';

    const widgetWrapper = document.createElement('div');
    widgetWrapper.className = 'tradingview-widget-container__widget';

    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;

    // Create config object with dynamic theme
    const config = {
      autosize: true,
      symbol: symbol ? symbol : "BINANCE:TRXUSDT",
      interval: "D",
      timezone: "Etc/UTC",
      theme: isLightMode ? "light" : "dark",
      style: "1",
      locale: "en",

      allow_symbol_change: false,
      hide_legend: true,

      disabled_features: [
        "header_symbol_search",
        "header_compare",
        "header_undo_redo",
        "header_screenshot",
        "header_settings",
        "header_indicators",
        "header_chart_type",
        "header_resolutions",
        "header_fullscreen_button",
        "symbol_info",
        "show_symbol_logo"
      ],

      enabled_features: [],
      support_host: "https://www.tradingview.com",
    };

    script.innerHTML = JSON.stringify(config);

    widgetContainer.appendChild(widgetWrapper);
    widgetContainer.appendChild(script);
    container.current.appendChild(widgetContainer);
  }, [isLightMode, symbol]); // re-run effect on theme change

  return (
    <div ref={container} style={{ height: '100%', width: '100%', overflow: 'scroll' }} />
  );
}

export default memo(TradingViewWidget);
